export function getCurrentAndPastYears(yearsBack: number): number[] {
  const currentYear = new Date().getFullYear();
  const years = Array(yearsBack + 1)
    .fill(0)
    .map((_, i) => currentYear - i);

  return years;
}
